import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { APP_CONFIG } from 'app.config';

@Component({
    selector: 'about',
    templateUrl: './about.component.html',
    encapsulation: ViewEncapsulation.None,
    // styleUrls: ['./about.component.scss'],
})
export class AboutComponent implements OnInit {
    appVersion: string;
    currentYear: string;

    /**
     * Constructor
     */
    constructor(
        public matDialogRef: MatDialogRef<AboutComponent>,
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------
    /**
     * On init
     */
    ngOnInit(): void {
        this.appVersion = APP_CONFIG.VERSION;
        this.currentYear = new Date().getFullYear().toString();
    }

    closeModal(): void {
        this.matDialogRef.close();
    }
}